import React from 'react';
import MessageLoader from '../assets/UserLoader'
import {
    RiSendPlaneFill,
    RiSearchFill,
    RiNotification3Fill,
    RiAddBoxFill
  } from "react-icons/ri";
  import { AiFillHome } from "react-icons/ai";
import { FaUserAlt } from "react-icons/fa";
import { useState ,useEffect} from 'react';
import { ChatState } from '../assets/context';
import {ENDPOINT} from "../assets/endpoint";

import axios from 'axios'
import { useNavigate } from 'react-router-dom';
function MobileNavbar() {
    const history = useNavigate()
    const [searchBox,setSearchbox] = useState(false)
    const[search,setsearch] =  useState()
    const [SearchResult,setSearchResult] = useState()
  const {user,chats,setChats
  ,setCreatepost} = ChatState();

const [loading,setLoading] = useState(false)
// SEARCH FUNCTION  
const SearchUser = async(e) =>{
    setsearch(e.target.value)
  
        setLoading(true)
        try {
          
            const {data} = await axios.post(`${ENDPOINT}/user?search=${e.target.value}`,{id:user._id})
            setSearchResult(data)
            setLoading(false)
  
        } catch (error) {
            console.log(error);
        }
  
  }
    // useEffect(()=>{
    //     SearchUser()
    // },[search])
  /////////////
  function Gotoprofile(id){

    setSearchbox(false)
    history(`/profile/?id=${id}`)

    
  }
  
  
  
  
  function Myprofile(){
    // setParams(user._id)
    history(`/profile/?id=${user._id}`)
  }
  
  ////////////
  
  function ShowSearch(){
    if(searchBox){
        setSearchbox(false)
        setsearch('')
    }else{
        setSearchbox(true)
        setsearch('')
    }
  }
 

  return (
        <>
        
        <div className="mobile_nav_Top">
        <h1>Chat here</h1>
            <RiNotification3Fill/>
        </div>
        {searchBox?(
            <div className="mobile_search_box">
                <div className="mobile_search_input">
                <input type="search" placeholder='Search...'  value={search} 
  onChange={SearchUser}/>
                </div>
                <div className="mobile_search_users">
                    {
                       
                            loading?<MessageLoader/>:(
                                SearchResult&&SearchResult.map((elem)=>{
                                    return(
                                        <div className="search_result_users" key={elem._id} >
                                        <div className="search_text"
                                        onClick={()=>Gotoprofile(elem._id)}
                                        >
                  
                                        
                                      <img src={elem.profilePicture} alt="Person" width="96" height="96" 
                                      onClick={()=>Gotoprofile(elem._id)}
                                      />
                                      <h3 >{elem.username}
                                      <h4>{elem.firstname+" "+ elem.lastname}</h4></h3>
                                      </div>
                                     
                                  </div>
                                    )
                                })
                            )
                           
                            }
               
                </div>


            </div>
        ):""}
        <div className="mobile_nav_bottom" id='hideIt'>
            <AiFillHome onClick={()=>history('/')}/>
            <RiSearchFill onClick={ShowSearch} />
            <RiAddBoxFill style={{transform:"scale(1.5)" }} onClick={()=>setCreatepost(true)}/>
            <RiSendPlaneFill onClick={()=>history('/message')} />
            <FaUserAlt onClick={Myprofile}/>
        </div>
        </>
    )
}

export default MobileNavbar